import apiClient from './client'
import { LiveEvent, StreamInfo } from '@/types/event'

export const eventsAPI = {
  getEvents: async (): Promise<LiveEvent[]> => {
    const response = await apiClient.get<any>('/events')
    // バックエンドはitemsプロパティでラップしている可能性があるので確認
    return response.data.items || response.data
  },

  getEvent: async (id: string): Promise<LiveEvent> => {
    const response = await apiClient.get<LiveEvent>(`/events/${id}`)
    return response.data
  },

  getStreamInfo: async (eventId: string): Promise<StreamInfo> => {
    // streaming.router は /stream プレフィックスで登録されている
    const response = await apiClient.get<StreamInfo>(`/stream/stream-info/${eventId}`)
    return response.data
  },

  joinEvent: async (eventId: string): Promise<void> => {
    await apiClient.post(`/live/events/${eventId}/viewers/join`)
  },

  leaveEvent: async (eventId: string): Promise<void> => {
    await apiClient.post(`/live/events/${eventId}/viewers/leave`)
  },
}